<template>
  <div
    class="hover-hand border rounded flex items-center px-4 py-3 my-1 hover:shadow transition duration-150 hover:border-challenge dark:hover:border-challenge text-gray-900 dark:border-dark-400 dark:text-dark-text dark:bg-dark-500"
    @click="onClick"
  >
    <span class="material-icons mr-4">
      <span v-if="problem.isSolved" class="text-challenge"> check_circle </span>
      <span v-else class="text-gray-500 dark:text-dark-text"> radio_button_unchecked </span>
    </span>
    <span class="border rounded text-xs p-1 mr-4 text-challenge border-challenge"> Day {{ day }} </span>
    <p class="text-2xl font-bold mt-2">{{ problem.name }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    problem: {
      type: Object,
      required: true
    },
    day: {
      type: Number,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  setup() {
    return {}
  }
})
</script>

<style>
.hover-hand {
  cursor: pointer;
  cursor: hand;
}
</style>
